export const resizeUrl = (url, { width, height }) => ([
	url,
	Object.entries({
		w: width,
		h: height,
		fit: 'max',
	}).filter(([k, v]) => v).map(([k, v]) => `${k}=${v}`).join('&'),
].filter(s => s.length).join('?'))
